import React, { useState } from 'react';
import Collapse from '@material-ui/core/Collapse';
import ListItem from '@material-ui/core/List';
import List from '@material-ui/core/List';
import { Link } from 'react-router-dom';
import './style.css';

const menus = [
	{
		id: 1,
		title: 'Accueil',
		link: '/',
	},

	{
		id: 2,
		title: "L'équipe",
		link: '/equipe',
		submenu: [
			{
				id: 21,
				title: 'Dimitri Van Wymeersch',
				link: '/equipe/dimitri-van-wymeersch',
			},
			{
				id: 22,
				title: 'Jean-François Gailly',
				link: '/equipe/jean-françois-gailly',
			},
			{
				id: 23,
				title: 'Maïté Abad Et Ortega',
				link: '/equipe/maite-abad-et-ortega',
			},
			{
				id: 24,
				title: 'Hugue Radelet',
				link: '/equipe/hugue-radelet',
			},
			{
				id: 25,
				title: 'Sadia Hartouane',
				link: '/equipe/sadia-hartouane',
			},
		],
	},

	{
		id: 3,
		title: 'Matières',
		link: '/practice',
		submenu: [
			{
				id: 31,
				title: 'Droit des assurances et réparation du dommage',
				link: '/matieres/assurances-et-reparation-du-dommage',
			},
			{
				id: 32,
				title: 'Droit de la circulation routière',
				link: '/matieres/circulation-routiere',
			},
			{
				id: 33,
				title: 'Droit des contrats',
				link: '/matieres/contrats',
			},
			{
				id: 34,
				title: 'Droit de la copropriété - Voisinage',
				link: '/matieres/copropriete',
			},
			{
				id: 35,
				title: 'Droit familial',
				link: '/matieres/familial',
			},
			{
				id: 36,
				title: 'Droit de la jeunesse',
				link: '/matieres/jeunesse',
			},
			{
				id: 37,
				title: 'Droit pénal',
				link: '/matieres/penal',
			},
			{
				id: 38,
				title: 'Droit de la responsabilité',
				link: '/matieres/responsabilite',
			},
			{
				id: 39,
				title: 'Droit des saisies',
				link: '/matieres/saisies',
			},
		],
	},
	{
		id: 4,
		title: 'Honoraires',
		link: '/honoraires',
	},
	{
		id: 5,
		title: 'Actualités',
		link: '/news',
	},
	{
		id: 6,
		title: 'Contact',
		link: '/contact',
	},
];

const MobileMenu = () => {
	const [openId, setOpenId] = useState(0);
	const [menuActive, setMenuState] = useState(false);

	const ClickHandler = () => {
		window.scrollTo(10, 0);
	};

	return (
		<div className='mobail_menu'>
			<div className={`mobileMenu ${menuActive ? 'show' : ''}`}>
				<div className='menu-close'>
					<div className='clox' onClick={() => setMenuState(!menuActive)}>
						<i className='ti-close'></i>
					</div>
				</div>

				<ul className='responsivemenu'>
					{menus.map((item, mn) => {
						return (
							<ListItem className={item.id === openId ? 'active' : null} key={mn}>
								{item.submenu ? (
									<>
										<p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
											{item.title}
											<i
												className={item.id === openId ? 'fa fa-angle-up' : 'fa fa-angle-down'}
											></i>
										</p>
										<Collapse in={item.id === openId} timeout='auto' unmountOnExit>
											<List className='subMenu'>
												{item.submenu.map((submenu, i) => {
													return (
														<ListItem key={i}>
															<Link
																onClick={ClickHandler}
																className='active'
																to={submenu.link}
															>
																{submenu.title}
															</Link>
														</ListItem>
													);
												})}
											</List>
										</Collapse>
									</>
								) : (
									<Link className='active' to={item.link}>
										{item.title}
									</Link>
								)}
							</ListItem>
						);
					})}
				</ul>
			</div>

			<div className='showmenu' onClick={() => setMenuState(!menuActive)}>
				<button type='button' className='navbar-toggler open-btn'>
					<span className='icon-bar first-angle'></span>
					<span className='icon-bar middle-angle'></span>
					<span className='icon-bar last-angle'></span>
				</button>
			</div>
		</div>
	);
};

export default MobileMenu;
